module.exports = __webpack_public_path__ + "img/5a3b5e6.png";